const quantityId = {
    LENGTH: 'LENGTH',
    ANGLE: 'ANGLE',
    TIME: 'TIME',
    SPEED: 'SPEED',
    ROTATION: 'ROTATION',
    MASS: 'MASS',
    AREA: 'AREA',
    VOLUME: 'VOLUME',
    ACCELERATION: 'ACCELERATION',
    NUMERIC: 'NUMERIC',
    TEMPERATURE: 'TEMPERATURE',
};

export default quantityId;